var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { map, filter, withLatestFrom, switchMap } from 'rxjs/operators';
import { CustomerApi, CustomersApi } from '@careapp/angular-sdk';
import { Actions, Effect } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Customers, CustomerFiles, RESPONSE_FILE_UPLOAD_COMPLETE } from '../actions/index';
import * as selectors from '../reducers/index';
import { MatDialog } from '@angular/material';
import { ConfirmationDialogComponent } from '../../shared/confirmation-dialog/confirmation-dialog.component';
var of = Observable.of;
var CustomerFilesEffects = /** @class */ (function () {
    function CustomerFilesEffects(store, actions$, adminApi, customerApi, dialog) {
        var _this = this;
        this.store = store;
        this.actions$ = actions$;
        this.adminApi = adminApi;
        this.customerApi = customerApi;
        this.dialog = dialog;
        this.assignFileToCustomer = this.actions$
            .ofType(RESPONSE_FILE_UPLOAD_COMPLETE).pipe(filter(function (action) { return action.payload.type === 'customer'; }), withLatestFrom(this.store.select(selectors.getSelectedId('customers'))), switchMap(function (_a) {
            var action = _a[0], id = _a[1];
            return _this.customerApi
                .addFile(id, action.payload.response)
                .map(function (res) { return Customers.ResponseSuccessAddCustomerFile(res); })
                .catch(function (err) { return of(Customers.ResponseFailAddCustomerFile); });
        }));
        this.removeFileFromCustomer = this.actions$
            .ofType(CustomerFiles.REQUEST_DESTROY_BY_ID).pipe(withLatestFrom(this.store.select(selectors.getSelectedId('customers'))), switchMap(function (_a) {
            var action = _a[0], id = _a[1];
            return _this.dialog
                .open(ConfirmationDialogComponent, {
                data: {
                    title: 'Remove File?',
                    body: 'Are you sure you want to remove this file? This can not be undone',
                    confirm: 'Delete',
                    cancel: 'Cancel',
                    confirmColor: 'warn'
                }
            })
                .afterClosed().pipe(map(function (result) { return [action, id, result]; }));
        }), switchMap(function (_a) {
            var action = _a[0], id = _a[1], result = _a[2];
            return result
                ? _this.customerApi
                    .removeFile(id, action.payload.id)
                    .map(function (res) { return CustomerFiles.ResponseSuccessDestroyByIdAction(action.payload); })
                    .catch(function (err) { return of(CustomerFiles.ResponseFailDestroyByIdAction(err)); })
                : of(CustomerFiles.ResponseFailDestroyByIdAction());
        }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], CustomerFilesEffects.prototype, "assignFileToCustomer", void 0);
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], CustomerFilesEffects.prototype, "removeFileFromCustomer", void 0);
    return CustomerFilesEffects;
}());
export { CustomerFilesEffects };
